// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1npFT","range":"MonthRangeSwitch_range__4AfQT","disabled":"MonthRangeSwitch_disabled__sxGiB"};